export const VIRTUAL_CAMPUS_ID = "VIRT";
export const RESOURCE_MODULE_IDS = {
	LIBRARY: 1,
	UNIVERSITY_SPACES: 2,
	OTHERS: 3,
};
export const ORGANIZER_IDS = {
	UNIVERSITY_LIFE: 1,
	COMPLEMENT_SERVICES: 6,
};
export const RESOURCES_CONSTANTS = {
	RESOURCE_TYPES_IDS: {
		TABLET: "S001",
		PC: "S002",
		GROUP_ROOM: "S003",
	},
	REASON_FOR_PENALIZE_IDS: {
		DELAY: 1,
		NO_REFUND: 2,
	},
	PENALTY_TYPE_IDS: {
		EQUIPMENT_REPLACEMENT: 1,
	},
	BLOCK_IDS: {
		TEMPORARY_BLOCK: 1,
		UNBLOCK: 2,
	},
	RESERVATION_TYPES: {
		REGULAR: 1,
		MANUAL: 2,
		EXTRA_HOURS: 3,
	},
	SPACE_TYPES_IDS: {
		// CANCHA
		FIELD: 1,
		// POLIDEPORTIVO
		SPORT_CENTER: 2,
		// ZONA VIDA UNIVERSITARIA
		UNIVERSITY_LIFE_ZONE: 3
	},
};
export const LOCATION_IDS = {
	ZOOM: 1,
	// LUGAR
	PLACE: 2,
};
export const EVENTS_CONSTANTS = {
	EVENT_TYPES: {
		// TALLERES
		WORK_SHOP: 1,
		CONFERENCES: 2,
		ACTIVITIES: 3,

	},
	EVENT_PERIOD_IDS: {
		EMPTY: 0,
		ONLY_DAY: 1,
		MANY_DAYS: 2,
	},
	EVENT_SUBTYPES: {
		CULTURAL: 1,
		SPORT: 2,
		OTHER: 3,
		PROFESSIONAL_TOOLS: 4,
	},
	FORM_ACTION_ERROR_CODES: {
		INVALID_CODE: "COD_NO_VALIDO",
		NO_RECORDS: "SIN_REGISTROS",
		TEACHER_EMAIL_NOT_EXISTS: "CORREO_DOC_NO_EXISTE",
		INACTIVE_TEACHER_ACCOUNT: "CUENTA_DOCENTE_INACTIVA",
		PENDING_INVITATION_OF_ZOOM_ACCOUNT: "PENDIENTE",
		INVALID_INVITATION_OF_ZOOM_ACCOUNT: "INVITACION_NO_VALIDA",
		LIMIT_EXCEEDED: "LIMITE_EXCEDIDO",
		UNEXPECTED_ERROR: "ERROR_INESPERADO",
		INCORRECT_VACANT_CAPACITY: "CAPACIDAD_VACANTES_INCORRECTO",
		ACCOUNT_WEBINAR_CANNOT_UPDATE_ANOTHER_ACCOUNT_TYPE: "CUENTA_SIN_ACCESO_WEBINAR",
		CREATE_EVENT_ERROR_PS: "ERROR_AL_CREAR_EVENTO_PS",
		CROSS_SCHEDULE: "ERR_CRUCE_HORARIO",
		CROSS_SCHEDULE_PS: "ERR_CRUCE_HORARIO_PS",
		UPDATE_EVENT_PS: "ERROR_ACTUALIZAR_PS",
		DELETE_EVENT_PS: "ERROR_AL_ELIMINAR_EVENTO_PS",
		TEACHER_NOT_SETTED: "ERR_DOCENTE_NO_ASIGNADO",
		NO_PAY_GRADE: "ERR_SIN_CAT_SALARIAL",
		NO_TEACHER_EMPLID_PS: "ERR_SIN_EMPLID_DOCENTE"
	},
	FORM_ERROR_TEXT_LIST_PER_FORM_ACTION_ERROR_CODE: {},
	FILENAME_REPORT_WAITLIST: "reporte_lista_espera.xlsx"
};
const { FORM_ACTION_ERROR_CODES } = EVENTS_CONSTANTS;

EVENTS_CONSTANTS.FORM_ERROR_TEXT_LIST_PER_FORM_ACTION_ERROR_CODE = {
	[FORM_ACTION_ERROR_CODES.TEACHER_EMAIL_NOT_EXISTS]:
		"El docente no tiene correo asociado.",
	[FORM_ACTION_ERROR_CODES.INVALID_INVITATION_OF_ZOOM_ACCOUNT]:
		"La cuenta de zoom tiene una invitación no válida.",
	[FORM_ACTION_ERROR_CODES.PENDING_INVITATION_OF_ZOOM_ACCOUNT]:
		"La cuenta de zoom tiene estado pendiente.",
	[FORM_ACTION_ERROR_CODES.LIMIT_EXCEEDED]:
		"El límite de reuniones creadas ha sido alcanzado.",
	[FORM_ACTION_ERROR_CODES.INACTIVE_TEACHER_ACCOUNT]:
		"La cuenta del docente está inactiva.",
	[FORM_ACTION_ERROR_CODES.UPDATE_EVENT_PS]:
		"Hubo un error al actualizar el evento (PS).",
	[FORM_ACTION_ERROR_CODES.CROSS_SCHEDULE_PS]:
		"Existe un cruce de horarios con el evento (PS).",
	[FORM_ACTION_ERROR_CODES.CROSS_SCHEDULE]:
		"Existe un cruce de horarios con el evento.",
	[FORM_ACTION_ERROR_CODES.CREATE_EVENT_ERROR_PS]:
		"Ocurrió un error al crear el evento (PS).",
	[FORM_ACTION_ERROR_CODES.DELETE_EVENT_PS]:
		"Ocurrió un error al eliminar el evento (PS).",
	[FORM_ACTION_ERROR_CODES.TEACHER_NOT_SETTED]: "Necesitas completar el campo de \"docente\" en el paso 2.",
	[FORM_ACTION_ERROR_CODES.NO_PAY_GRADE]: "Necesitas completar el campo de \"categoría salarial\" en el paso 2.",
	[FORM_ACTION_ERROR_CODES.NO_TEACHER_EMPLID_PS]: "El docente asignado no cuenta con un código \"emplid\" (PS). Selecciona otro o ingresa el nombre y elige una cuenta."
};

export const EVENT_PERIODS = [
	{ value: EVENTS_CONSTANTS.EVENT_PERIOD_IDS.ONLY_DAY, label: "Día único" },
	{
		value: EVENTS_CONSTANTS.EVENT_PERIOD_IDS.MANY_DAYS,
		label: "Varios días",
	},
];
export const PUBLIC_LOADS_IDS = {
	GENERAL: 1,
	FILE: 2,
};
export const ACAD_REINFORCE_CONSTANTS = {
	ADD_STUDENT_TO_ACAD_REINFORCE_RESERVATION_MESSAGES: {
		VACANCY_LIMIT: "LIMITE_VACANTES",
	},
	FORM_ERRORS: {
		LIMIT_EXCEEDED: "LIMITE_EXCEDIDO",
		CROSS_SCHEDULE: "ERR_CRUCE_HORARIO",
		UPDATE_HOST_NOT_LICENSED_ACCOUNT: "ACT_HOST_CUENTA_SIN_LICENCIA",
		TUTOR_EMAIL_NOT_EXISTS: "CORREO_DOC_NO_EXISTE",
		INVALID_STUDENT_CODE_IN_FILE_OF_PUBLIC: "COD_NO_VALIDO",
		TUTOR_ACCOUNT_IS_NOT_LICENSED: "DOCENTE_SIN_LICENCIA",
		ENVIRONMENT_NOT_AVAILABLE: "AMBIENTE_NO_DISPONIBLE",
		UNEXPECTED_ERROR: "UNEXPECTED_ERROR",
		PS_ERROR: "ERROR_ACTUALIZAR_PS",
	},
};
export const APPOINTMENTS_CONSTANTS = {
	FORM_ACTION_ERROR_CODES: {
		CROSS_SCHEDULE: "ERR_CRUCE_HORARIO",
		CROSS_SCHEDULE_EMPLOYABILITY: "EMP_CRUCE_AGENDA_ASESOR",
		FOR_ADVISER_ACCOUNT: {
			INACTIVE_ADVISER_ACCOUNT: "CUENTA_PSI_INACTIVA",
			NOT_EXISTS_ADVISER_ACCOUNT: "CUENTA_PSI_NO_EXISTE",
			NOT_EXISTS_EMPLOYABILITY_ADVISER: "EMP_ASESOR_NO_EXISTE",
			INACTIVE_EMPLOYABILITY_ADVISER: "EMP_ASESOR_INACTIVO",
			PENDING_PSI_ACCOUNT: "CUENTA_PSI_PENDIENTE",
			INVALID_INVITATION: "INVITACION_NO_VALIDA",
		},
	},
	MESSAGE_ACCORDS_ERROR: {},
};
APPOINTMENTS_CONSTANTS.MESSAGE_ACCORDS_ERROR = {
	[APPOINTMENTS_CONSTANTS.FORM_ACTION_ERROR_CODES.FOR_ADVISER_ACCOUNT
		.INACTIVE_ADVISER_ACCOUNT]: "La cuenta del psicólogo está inactiva.",
	[APPOINTMENTS_CONSTANTS.FORM_ACTION_ERROR_CODES.FOR_ADVISER_ACCOUNT
		.NOT_EXISTS_ADVISER_ACCOUNT]:
		"El psicólogo no posee una cuenta de zoom.",
	[APPOINTMENTS_CONSTANTS.FORM_ACTION_ERROR_CODES.FOR_ADVISER_ACCOUNT
		.NOT_EXISTS_EMPLOYABILITY_ADVISER]:
		"El asesor seleccionado no existe o no corresponde al rol de Empleabilidad.",
	[APPOINTMENTS_CONSTANTS.FORM_ACTION_ERROR_CODES.FOR_ADVISER_ACCOUNT
		.INACTIVE_EMPLOYABILITY_ADVISER]:
		"El asesor seleccionado se encuentra inactivo.",
	[APPOINTMENTS_CONSTANTS.FORM_ACTION_ERROR_CODES.FOR_ADVISER_ACCOUNT
		.PENDING_PSI_ACCOUNT]:
		"La cuenta de zoom del psicólogo está pendiente.",
	[APPOINTMENTS_CONSTANTS.FORM_ACTION_ERROR_CODES.FOR_ADVISER_ACCOUNT
		.INVALID_INVITATION]:
		"La cuenta de zoom del psicólogo tiene una invitación inválida.",
};
